import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-credit-requests',
  templateUrl: './credit-requests.component.html',
  styleUrls: ['./credit-requests.component.scss']
})
export class CreditRequestsComponent implements OnInit {

  requests: any[] = [];
  statusFilter = 'pending';
  statusOptions = [
    { label: 'En attente', value: 'pending' },
    { label: 'Acceptées', value: 'accepted' },
    { label: 'Refusées', value: 'refused' },
    { label: 'Toutes', value: '' },
  ];

  displayAction = false;
  actionType: 'accepted' | 'refused' = 'accepted';
  selectedRequest: any;
  adminComment = '';
  notifyClient = false;
  clientMailSubject = '';
  clientMailBody = '';
  saving = false;

  constructor(public api: ApiService) {}

  ngOnInit() {
    this.refresh();
  }

  private adminAuth() {
    const admin = this.api.adminUser.value;
    if (!admin || !admin.ebp_id || !admin.token) {
      return null;
    }
    return {
      id_user: admin.ebp_id,
      token: admin.token,
    };
  }

  refresh() {
    const auth = this.adminAuth();
    if (!auth) {
      this.requests = [];
      return;
    }

    this.api.post('credit=list', {
      ...auth,
      status: this.statusFilter,
    }).then((res: any) => {
      if (res && res.statut == 'success') {
        this.requests = res.data || [];
      } else {
        this.requests = [];
        if (res && res.message) {
          this.api.error(res.message);
        }
      }
    });
  }

  openAction(row: any, type: 'accepted' | 'refused') {
    this.selectedRequest = row;
    this.actionType = type;
    this.adminComment = row.admin_comment || '';
    this.notifyClient = false;
    this.clientMailSubject = this.defaultRefuseSubject(row);
    this.clientMailBody = this.defaultRefuseBody(row, this.adminComment);
    this.displayAction = true;
  }

  onNotifyChange() {
    if (this.notifyClient && this.actionType === 'refused' && this.selectedRequest) {
      this.clientMailSubject = this.defaultRefuseSubject(this.selectedRequest);
      this.clientMailBody = this.defaultRefuseBody(this.selectedRequest, this.adminComment);
    }
  }

  defaultRefuseSubject(row: any) {
    return "Demande d'avoir refusée - " + (row.InvoiceDocumentNumber || '');
  }

  defaultRefuseBody(row: any, comment: string) {
    let body =
      'Bonjour,\n\n' +
      "Votre demande d'avoir concernant la facture " +
      (row.InvoiceDocumentNumber || '') +
      ' (produit ' +
      (row.ItemId || '') +
      ') a été refusée.\n\n';
    if (comment && comment.trim()) {
      body += 'Commentaire :\n' + comment.trim() + '\n\n';
    }
    body += 'Cordialement,\nBlackrock Games';
    return body;
  }

  confirmAction() {
    const auth = this.adminAuth();
    if (!this.selectedRequest || !auth) {
      return;
    }

    if (this.notifyClient && this.actionType === 'refused') {
      if (!this.clientMailSubject.trim() || !this.clientMailBody.trim()) {
        this.api.error("Merci de renseigner l'objet et le contenu de l'email client.");
        return;
      }
    }

    this.saving = true;
    this.api.post('credit=updateStatus', {
      ...auth,
      id_credit_request: this.selectedRequest.id_credit_request,
      status: this.actionType,
      admin_comment: this.adminComment || null,
      notify_client: this.notifyClient ? 1 : 0,
      client_mail_subject: this.actionType === 'refused' ? this.clientMailSubject : null,
      client_mail_body: this.actionType === 'refused' ? this.clientMailBody : null,
    }).then((res: any) => {
      this.saving = false;
      if (res && res.statut == 'success') {
        this.api.success(this.actionType === 'accepted' ? 'Demande acceptée' : 'Demande refusée');
        this.displayAction = false;
        this.refresh();
      } else {
        this.api.error((res && res.message) || 'Mise à jour impossible');
      }
    }).catch(() => {
      this.saving = false;
      this.api.error('Mise à jour impossible');
    });
  }

  statusLabel(status: string) {
    if (status === 'accepted') return 'Acceptée';
    if (status === 'refused') return 'Refusée';
    return 'En attente';
  }

  photoList(row: any): string[] {
    if (!row || !row.photo) {
      return [];
    }
    if (Array.isArray(row.photo)) {
      return row.photo;
    }
    try {
      const parsed = JSON.parse(row.photo);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch (e) {}
    return [row.photo];
  }

  statusSeverity(status: string) {
    if (status === 'accepted') return 'success';
    if (status === 'refused') return 'danger';
    return 'warning';
  }
}
